import * as React from 'react';
import { Button, Caption, Checkbox, MaskedInput, Select, TDeviceType, TOptionValue } from '@cian/ui-kit';
import * as style from './styles.css';
import { CONSENT_PERSONAL_DATA, PRIVACY_POLICY } from 'shared/landingSeller/constants/links';
import { TFormProps } from 'shared/common/types/form';
import { clsx } from 'clsx';
import { TRegion } from 'shared/common/types/regions';
import { EModalSource } from 'shared/common/types/modal';

interface IFormProps extends TFormProps {
  onSubmit: (e: React.FormEvent<HTMLFormElement>) => void;
  onSelectPolygon: (value: TOptionValue) => void;
  phoneValue: string;
  onChangePhone: (value: string) => void;
  regions: TRegion[];
  isDesktop: boolean;
  isStandartTheme: boolean;
  formIsLoading: boolean;
  device: TDeviceType;
  btnIsDisabled: boolean;
  source?: EModalSource;
  subtitle?: string;
  btnTitle?: string;
  marketingAgreementUrl?: string;
  isChecked: boolean;
  toggleCheckbox: () => void;
}

export const Form: React.FC<IFormProps> = ({
  onSubmit,
  onSelectPolygon,
  onChangePhone,
  phoneValue,
  isStandartTheme,
  theme,
  device,
  isModalForm,
  regions,
  formIsLoading,
  btnIsDisabled,
  source,
  title,
  subtitle,
  btnTitle,
  marketingAgreementUrl,
  isChecked,
  toggleCheckbox,
}) => {
  const isMobile = device === 'phone';
  const isWhiteTheme = theme === 'white';
  const modalMessage =
    source === EModalSource.Consultation
      ? {
          title: <span>Остались вопросы? Мы готовы на них ответить</span>,
          subtitle: 'Мы перезвоним и ответим на все вопросы',
          cta: 'Позвоните мне',
        }
      : {
          title: <span>Оставьте заявку на&nbsp;продажу вместе c&nbsp;Цианом</span>,
          subtitle: <span>Мы перезвоним и&nbsp;ответим на все вопросы</span>,
          cta: 'Отправить заявку',
        };

  return (
    <div className={clsx(style['container'], style[device], style[theme], isModalForm && style['modal'])}>
      <div className={clsx(style['title'], style[device])}>{title || modalMessage.title}</div>
      <div className={clsx(style['descr'], style[device])}>{subtitle || modalMessage.subtitle}</div>
      <form className={clsx(style['form'], style[device])} onSubmit={e => onSubmit(e)}>
        <div className={style['input-wrapper']}>
          <MaskedInput
            value={phoneValue}
            onChange={value => onChangePhone(value)}
            lazy
            width={'100%'}
            size="M"
            name="phone"
            mask="+7 (000) 000 00-00"
            placeholder="Номер телефона"
          />
        </div>
        <div className={style['input-wrapper']}>
          <Select width={'100%'} onChange={onSelectPolygon} size="M" options={regions} placeholder="Выберите регион" />
        </div>
        <div className={style['input-wrapper']}>
          <Button
            loading={formIsLoading}
            disabled={btnIsDisabled}
            size="M"
            theme={isStandartTheme ? 'fill_secondary' : 'fill_primary'}
            fullWidth={isMobile}
          >
            {btnTitle || modalMessage.cta}
          </Button>
        </div>
      </form>
      <div className={style['legal']}>
        {marketingAgreementUrl && (
          <div className={style['marketing']} data-name="AgreementMarketing">
            <Checkbox checked={isChecked} onChange={toggleCheckbox} dataTestId={'marketing_agreement'} />
            <Caption color={isWhiteTheme ? 'text-inverted-default' : 'text-secondary-default'}>
              Соглашаюсь на{' '}
              <a href={marketingAgreementUrl} className={style['link']} target="_blank" rel="noopener noreferrer">
                рассылки и звонки
              </a>
            </Caption>
          </div>
        )}
        <div className={style['secury']}>
          <Caption color={isWhiteTheme ? 'text-inverted-default' : 'text-primary-default'}>
            {`Нажимая «${btnTitle || modalMessage.cta}», я даю`}{' '}
            <a href={CONSENT_PERSONAL_DATA} target="_blank" className={style['link']} rel="noreferrer">
              Согласие на обработку персональных данных
            </a>{' '}
            в соответствии с{' '}
            <a href={PRIVACY_POLICY} target="_blank" className={style['link']} rel="noreferrer">
              Политикой конфиденциальности
            </a>
          </Caption>
        </div>
      </div>
    </div>
  );
};
